import { render } from "./PlaybookViewEvents.vue?vue&type=template&id=6b38df94&scoped=true"
import script from "./PlaybookViewEvents.vue?vue&type=script&lang=js"
export * from "./PlaybookViewEvents.vue?vue&type=script&lang=js"

import "./PlaybookViewEvents.vue?vue&type=style&index=0&id=6b38df94&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b38df94"]])

export default __exports__